<template>
    <div>
        <div class="modal_header">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24">
                    <div class="grid-content bg-purple">
                        <div class="title_h">
                            {{$t('message.update_bunk')}}
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24">
                    <div class="grid-content bg-purple-light">
                        <el-row class="button_r">
                           <el-button type="success" :loading="loadingButton" :disabled="loadingButton ? true : false" @click="submit(true)">{{$t('message.save_and_close')}}</el-button>
                            <el-button @click="close()">{{$t('message.close')}}</el-button>
                        </el-row>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="row" v-loading="loadingData">
            <div class="col-12 mt-2">
                <div class="modal-body">
                    <el-form  ref="form" :model="form"  :rules="rules" class="aticler_m" size="small">
                        <el-row :gutter="25">
                            <el-col :sm="12">
                                <el-form-item :label="$t('message.corps')" prop="corps_id">
                                    <corpses v-model="form.corps_id" :corps_id="form.corps_id" size="mini"/>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12">
                                <el-form-item :label="$t('message.floor')" prop="floor_id">
                                     <floors v-model="form.floor_id" :floor_id="form.floor_id" size="mini"/>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12">
                                <el-form-item :label="$t('message.room')" prop="hospital_room_id" >
                                    <hospitalRooms v-model="form.hospital_room_id" :hospital_room_id="form.hospital_room_id" size="mini"/>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12">
                                <el-form-item :label="$t('message.class')" prop="classs_id">
                                    <classes v-model="form.classs_id" :classs_id="form.classs_id" size="mini"/>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="12">
                                <el-form-item :label="$t('message.bunk')" prop="name">
                                    <el-input v-model="form.name" autocomplete="off"/>
                                </el-form-item>
                            </el-col>
                            <!-- end col -->
                        </el-row>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters,mapActions} from 'vuex';
    import form from '@/utils/mixins/form';
    import corpses from '@/components/selects/corps';
    import classes from '@/components/selects/class';
    import floors from '@/components/selects/floor';
    import hospitalRooms from '@/components/selects/hospitalRoom';
    import drawerChild from '@/utils/mixins/drawer-child';
    import PatientHistoryType from "@/components/selects/patientHistoryType.vue";
    
    export default {
        mixins:[form, drawerChild],
        props: ['selected'],
        components:{
            PatientHistoryType,
            corpses,
            floors,
            classes,
            hospitalRooms,
        },
        data(){
            return {
                 loadingData: false
            }
        },
        // watch: {
        //     reloadModel: {
        //         handler: function () {
        //             if (this.reloadModel){
        //                 this.loadModel()
        //             }
        //         },
        //         deep: true
        //     },
        // },
        created(){},
        computed: {
            ...mapGetters({
                rules: 'bunks/rules',
                model: 'bunks/model',
                columns: 'bunks/columns'
            })
        },
        methods:{
            ...mapActions({
                save: 'bunks/update',
                editModel: 'bunks/show',
                empty: 'bunks/empty',
            }),
            afterOpened(){
                if (this.selected && !this.loadingData) {
                    this.loadingData = true;
                    this.editModel(this.selected.id)
                        .then(async (res) => {
                            this.loadingData = false;
                            this.form = JSON.parse( JSON.stringify(this.model) );
                        })
                        .catch(err => {
                            this.loadingData = false;
                            this.$notify({
                                title: "Ошибка",
                                type: "error",
                                offset: 130,
                                message: err.error.message,
                            })
                        });                    
                }

            },
            afterClosed(){
              this.empty()
            },
            // loadModel(){
            //     this.form = JSON.parse( JSON.stringify( this.model ));
            // },
            submit(close = true){
                this.$refs['form'].validate((valid) => {
                    if (valid){
                        this.loadingButton = true;
                        this.save(this.form)
                            .then(res => {
                                this.loadingButton = false;
                                this.$notify({
                                    title: 'Успешно',
                                    type: "success",
                                    offset: 130,
                                    message: res.message
                                });
                                this.parent().listChanged()
                                if (close == true) {
                                    this.close();
                                }
                            })
                            .catch(err => {
                                this.loadingButton = false;
                                this.$notify({
                                    title: 'Ошибка',
                                    type: "error",
                                    offset: 130,
                                    message: err.error.message
                                });
                            });
                    }
                });
            }
        }
    }

</script>
